import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess, staticc } from "../../Components/General/Notification";

const LoginAdmin = () => {
    return ({
        type: types.LOGIN_ADMIN
    })
}

const LogoutAdmin = () => {
    return ({
        type: types.LOGOUT_ADMIN,
    })
}

const getUsers = (users) => {
    return ({
        type: types.GET_USERS,
        payload: users
    })
}

const sendNotify = () => {
    return ({
        type: types.SEND_NOTIFICATIONS
    })
}


export const AuthLogin = (email, password, navigate,setloadBtn) => {
    const Dataa = new FormData();
    Dataa.append('email', email);
    Dataa.append('password', password);
    return function (dispatch) {
        setloadBtn(true)
        // axios.post(`${staticc}/api/login?email=${email}&password=${password}`,).then((res) => {
        axios.post(`${staticc}/api/login`,Dataa).then((res) => {
            console.log(res);
            console.log(res.data.data.role_id);
            if (res.data.message == "success") {
                localStorage.setItem("tokenA", res.data.data.token)
                localStorage.setItem("roleA", res.data.data.role_id)
                dispatch(LoginAdmin());
                setloadBtn(false)
                navigate('/')
                window.location.reload();
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
            setloadBtn(false)
        })
    }
}

export const AuthLogout = (navigate) => {
    return function (dispatch) {
        //dispatch({ type: types.LOADING_LOGOUT, payload: true });
        let token = localStorage.getItem("tokenA");
        console.log(token);
        axios.post(`${staticc}/api/logout`,{}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(LogoutAdmin());
                //dispatch({ type: types.LOADING_LOGOUT, payload: false });
                localStorage.removeItem('tokenA');
                navigate('/')
                window.location.reload();
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
            //dispatch({ type: types.LOADING_LOGOUT, payload: false });
        })
    }
}

export const loadUsers = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/users`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getUsers(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const SendNotificationn = (title,body,setloadBtn) => {
    return function (dispatch) {
        setloadBtn(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/notification-send`,{
            title,body
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(sendNotify());
                notifysuccess(res.data.message)
                setloadBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
            setloadBtn(false)
        })
    }
}